<template>
  <main class="login">
    <h1>Login</h1>
    <form class="login-form" @submit.prevent="login">
      <div class="form-row">
        <div class="label-wrapper">
          <label for="username">Username</label>
          <div class="trigger-how-to-find-builderlynx" @click="howtofindmodal = true">SHOW ME HOW TO FIND IT</div>
        </div>
        <input required v-model="username" type="text" placeholder="Username" id="username"/>
      </div>
      <div class="form-row">
        <div class="label-wrapper">
          <label for="password">Password</label>
        
          <div class="trigger-how-to-find-builderlynx" @click="howtofindmodal = true">SHOW ME HOW TO FIND IT</div>
        </div>
        <input required v-model="password" type="password" placeholder="Password" id="password"/>
      </div>
      <vs-button
          :loading="authStatus === 'loading'"
          color="#F15A35"
          :active="false"
      >
        Login
      </vs-button>
    </form>
    <vs-dialog width="550px" not-center v-model="howtofindmodal">
        <template #header>
          <h4 class="not-margin">
            How to find your <b>BuilderLynx</b> login credentials
          </h4>
        </template>


        <div class="con-content">
          <div class="video-ratio-wrapper">
            <iframe class="video-embed" src="https://player.vimeo.com/video/503164597?autoplay=1" width="100%" height="300px" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>

        <template #footer>
          <div class="con-footer">
            <vs-button @click="howtofindmodal=false" color="#f15a35">
              Got it
            </vs-button>
          </div>
        </template>
      </vs-dialog>
  </main>
</template>

<script>
export default {
  name: "Login.vue",
  data() {
    return {
      username: "",
      password: "",
      howtofindmodal: false
    }
  },
  methods: {
    login: function () {
      let username = this.username
      let password = this.password
      // console.log('this.$store.state.status',this.$store.state.status)
      this.$store.dispatch('login', {username, password})
          .then(() => this.$router.push('/'))
          .catch(err => {
            console.log(err)
            this.$vs.notification({
              color: 'danger',
              duration: 4000,
              title: 'Failed to Login',
              text: err
            })
          })
    }
  },
  computed: {

    authStatus: function () {
      return this.$store.getters.authStatus
    }
  },
}
</script>

<style scoped lang="sass">
main.login
  form.login-form
    width: 300px
    margin: 2em auto

    .form-row
      margin-bottom: 1em
      .label-wrapper
        display: flex
        flex-direction: row
        align-items: flex-end
        justify-content: space-between
      label
        font-size: 1em
        margin-bottom: 0.25em
        display: block
        text-align: left
      .trigger-how-to-find-builderlynx
        cursor: pointer
        font-size: 10px

      input
        display: block
        width: 100%
        padding: 0.5em
        border-radius: 5px
        border: 1px solid rgba(black,0.5)

    button
      display: inline-block
      font-size: 1.2em

</style>
